export default "__VITE_ASSET__iiM24zir__"